import React from "react";
import Aux from "../../hoc/Auxiliary"
import {Message} from 'primereact/message';

const NotAuthorized = (props) => {

    return (
        <Aux>
            <div className="grid">
                <div className="col-12 flex align-items-center justify-content-center" style={{color: "#487c84"}}>
                    <h3> Access Denied </h3>
                </div>
                <div className="col-12">
                    <Message style={{width: '100%'}}
                             severity="error" icon="pi pi-lock"
                             text="You are not authorized to access this page."></Message>
                </div>
            </div>


        </Aux>

    );
}
export default NotAuthorized;
